// extracted by mini-css-extract-plugin
module.exports = {"manualSkeleton":"ManualSkeleton_manualSkeleton__1N4-L","ant-skeleton-loading":"ManualSkeleton_ant-skeleton-loading__3F99v"};